import React from 'react';
import { formatNumber } from '../../../core/helpers/format-number';

import { TableCol5Model } from '../../../core/models/tables';

import './SettlementTable.scss';

interface ISettlementTable {
  data: TableCol5Model[];
}

export default function SettlementTable({ data }: ISettlementTable): JSX.Element {
  return (
    <div className="SettlementTable">
      <div className="table-container">
        <table className="total-table total-table-stripped table-lg">
          <thead>
            <tr>
              <th>
                <span>Settlement</span>
                <br />
                <span className="SettlementTable__below-header">Date</span>
              </th>
              <th>
                <span>Daily Max. System Buy Price</span>
                <br />
                <span className="SettlementTable__below-header">(SBP) £/MWh</span>
              </th>
              <th>
                <span>Time of Max. SBP price</span>
                <br />
                <span className="SettlementTable__below-header">(local time)</span>
              </th>
              <th>
                <span>Daily Min. System Sell Price</span>
                <br />
                <span className="SettlementTable__below-header">(SSP) £/MWh</span>
              </th>
              <th>
                <span>Time of Min. System Sell Price</span>
                <br />
                <span className="SettlementTable__below-header">(SSP/ local time)</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((settlement, index) => (
              <tr key={index}>
                <td>{settlement.col1}</td>
                <td>{formatNumber(settlement.col2)}</td>
                <td>{settlement.col3}</td>
                <td>{formatNumber(settlement.col4)}</td>
                <td>{settlement.col5}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
